import React from 'react';
import { Star, Quote, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Reviews() {
  const reviews = [{
    name: 'Sarah M.',
    location: 'Gosnells',
    text: "Excellent service, quality workmanship and value for money. Couldn't be happier with the result.",
    rating: 5,
    date: '2 weeks ago',
    initials: 'SM',
    color: 'bg-blue-100 text-blue-700'
  }, {
    name: 'James T.',
    location: 'Maddington',
    text: 'I am a repeat customer of Completely Electrical; they are my go to electricians. Always professional and reliable.',
    rating: 5,
    date: '1 month ago',
    initials: 'JT',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    name: 'Emma W.',
    location: 'Thornlie',
    text: 'Great service, great price and friendly staff. Had a split system installed and new pendant lights — the place looks amazing now.',
    rating: 5,
    date: '2 months ago',
    initials: 'EW',
    color: 'bg-purple-100 text-purple-700'
  }, {
    name: 'Mark D.',
    location: 'Southern River',
    text: 'Had all the lighting upgraded in our new build — the builder-standard stuff was terrible. Completely Electrical transformed the whole house with premium downlights and strip lighting.',
    rating: 5,
    date: '3 weeks ago',
    initials: 'MD',
    color: 'bg-amber-100 text-amber-700'
  }, {
    name: 'Lisa K.',
    location: 'Harrisdale',
    text: 'Called for an emergency on a Saturday night — power out in the whole house. They responded quickly and had everything sorted. Absolute lifesavers.',
    rating: 5,
    date: '1 week ago',
    initials: 'LK',
    color: 'bg-rose-100 text-rose-700'
  }];
  return <section className="py-20 lg:py-28 bg-cream" data-id="element-458">
      <div className="max-w-7xl mx-auto px-4" data-id="element-459">
        <div className="flex flex-col md:flex-row justify-between items-end mb-14 gap-8" data-id="element-460">
          <div className="max-w-2xl" data-id="element-461">
            <span className="text-orange font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-462">
              Don't Take Our Word For It
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6 tracking-tighter" data-id="element-463">
              What Perth Locals Say About Us
            </h2>

            <div className="flex items-center gap-4 bg-white px-6 py-4 rounded-xl shadow-sm border border-gray-100 inline-flex" data-id="element-464">
              <div className="flex flex-col items-center justify-center border-r border-gray-100 pr-4" data-id="element-465">
                <span className="text-3xl font-heading font-extrabold text-navy leading-none" data-id="element-466">
                  5.0
                </span>
                <span className="text-[10px] font-bold text-gray-400 mt-0.5" data-id="element-467">
                  437 reviews
                </span>
              </div>
              <div className="flex flex-col gap-1" data-id="element-468">
                <div className="flex text-yellow-400" data-id="element-469">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-current" data-id="element-470" />)}
                </div>
                <span className="text-sm font-bold text-slate flex items-center gap-1" data-id="element-471">
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-white shadow-sm border border-gray-100 font-extrabold text-[12px]" data-id="element-472">
                    <span className="bg-clip-text text-transparent bg-gradient-to-br from-blue-500 via-red-500 to-yellow-500" data-id="element-473">
                      G
                    </span>
                  </span>
                  Based on Google Reviews
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-474">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-7 rounded-2xl shadow-sm border-l-4 border-orange border-y border-r border-y-gray-100 border-r-gray-100 relative flex flex-col h-full" data-id="element-475">
              <Quote className="w-8 h-8 text-gray-100 absolute top-6 right-6" data-id="element-476" />

              <div className="flex text-yellow-400 mb-5" data-id="element-477">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-478" />)}
              </div>

              <p className="text-slate mb-7 relative z-10 leading-relaxed flex-grow text-sm" data-id="element-479">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3 border-t border-gray-50 pt-5 mt-auto" data-id="element-480">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${review.color}`} data-id="element-481">
                  {review.initials}
                </div>
                <div data-id="element-482">
                  <h4 className="font-extrabold text-navy text-sm" data-id="element-483">
                    {review.name}
                  </h4>
                  <span className="text-xs text-gray-500 font-medium" data-id="element-484">
                    {review.location} • {review.date}
                  </span>
                </div>
              </div>
            </motion.div>)}

          {/* 6th Card - CTA */}
          <motion.a href="https://www.google.com/search?q=completely+electrical+huntingdale+reviews" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-navy p-7 rounded-2xl shadow-lg relative flex flex-col items-center justify-center text-center group hover:bg-navy-600 transition-colors cursor-pointer h-full min-h-[250px]" data-id="element-485">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-5 shadow-md" data-id="element-486">
              <Star className="w-8 h-8 text-orange fill-orange" data-id="element-487" />
            </div>
            <h3 className="text-2xl font-heading font-extrabold text-white mb-3" data-id="element-488">
              Read All 437 Reviews
            </h3>
            <p className="text-gray-200 mb-6 text-sm" data-id="element-489">
              See why Perth's south side rates us 5 stars on Google.
            </p>
            <div className="flex items-center gap-2 text-orange font-extrabold group-hover:text-white transition-colors" data-id="element-490">
              View on Google
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-491" />
            </div>
          </motion.a>
        </div>
      </div>
    </section>;
}